import { defineStore } from 'pinia'

export const useAppSettingStore = defineStore('appSetting', {
    state: () => ({
        is_audit_today:true,
    }),
    actions: {
    },
    persist: true,
})
